import * as CONSTRUCTOR from '../../generate';

export const projectTrackerResponse = CONSTRUCTOR.FRAGMENT({
  name: 'ProjectTrackerInfo',
  fragmentName: 'ProjectTrackerResponseFields',
  fields: `{
    loan_tracker_project_id
  }`,
});

export const leadResponse = CONSTRUCTOR.FRAGMENT({
  name: 'Lead',
  fragmentName: 'LeadResponseFields',
  fields: `{
    id
    code
    user_id
    company_id
    developer_project_id
    name
    preferred_name
    mobile_prefix
    mobile
    email
    identity
    identity_type
    loan_amount
    status
    opportunity_id
    created_at
    updated_at
  }`,
});

export const leadActivityResponse = CONSTRUCTOR.FRAGMENT({
  name: 'LeadActivity',
  fragmentName: 'LeadActivityResponseFields',
  fields: `{
    id
    user_id
    message
    type
    lead_id
    created_at
    updated_at
  }`,
});

export const leadActivityLogsResponse = CONSTRUCTOR.FRAGMENT({
  name: 'ListLeadActivityLogsResponse',
  fragmentName: 'LeadActivityLogsResponseFields',
  fields: `{
    activity_logs {
      id
      user_id
      message
      type
      lead_id
      created_at
      updated_at
    }
    total_count
    limit
    offset
  }`,
});
